const selectors = {
  list: (state) => state.parents.list,
  parentsListLoaded: (state) => state.parents.parentsListLoaded,

  filters: (state) => state.parents.filters,
  preparedEntities: (state) => state.parents.preparedEntities,
  pagination: (state) => state.parents.pagination,
};

export { selectors };
